import script from "./asLeadsPortal.vue?vue&type=script&lang=ts&setup=true"
export * from "./asLeadsPortal.vue?vue&type=script&lang=ts&setup=true"

import "./asLeadsPortal.vue?vue&type=style&index=0&id=6bff5d32&lang=less&scoped=true"

import exportComponent from "/builds/26732/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bff5d32"]])

export default __exports__